import { useTranslation } from 'react-i18next';

import { InfoSection, InfoSectionWrapper, StyledTitle } from 'components/containers/InfoSection';

export const ResetPasswordSuccess = () => {
  const { t } = useTranslation('account');

  return (
    <InfoSectionWrapper>
      <InfoSection onSuccess={true} />
      <StyledTitle>{t('password.password-changed')}</StyledTitle>
    </InfoSectionWrapper>
  );
};
